module.exports = __webpack_public_path__ + "img/twitch.c3a350b6.png";